module.exports = {"labels":{"email":"E-mail principal","phone":"Telefone","mobile":"Celular","checkbox":"Desejo receber promoções e novidades Veloe.","submit":"Salvar"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/EditContactDataForm/data.json
// module id = 1727
// module chunks = 0